var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-wrapper"},[_c('ul',{staticClass:"ul-sidebar"},_vm._l((_vm.links),function(link){return _c('li',{key:link.id},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(link.href),expression:"link.href"}]},[_vm._v(_vm._s(link.name))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2789e140","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ScrollTo.vue
// module id = 173
// module chunks = 0